import React from 'react'
import styles from './title.module.css'

export const Title = ({ projectTitle }: { projectTitle: string }) => {
  return <h1 className={styles.container}>{projectTitle}</h1>
}
